import React from 'react';
import {ColumnHeaderSortable} from '../../DataTable/index.jsx';
import Column from './base.jsx';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from "react-bootstrap/Popover";
import CurrentUser from '@scripts/utilities/current-user.js';

const columnOptions = {
    id: 'col-reward',
    title: 'Reward'
};

const REWARD_LEVELS_SORT = {
    "Negative Reward": 1,
    "Very Low": 2,
    "Low": 3,
    "Moderate": 4,
    "High": 5,
    "Very High": 6
};
class HeaderColumn extends ColumnHeaderSortable {
    get id() {
        return columnOptions.id;
    }

    get title() {
        return columnOptions.title;
    }

    get overlayText() {
        return "Collective Shift's reward rating of cryptocurrencies";
    }
}

class DetailColumn extends React.Component {
    constructor(props) {
        super(props);
        this.getClass = this.getClass.bind(this);
        this.overlay = this.overlay.bind(this);
    }

    getClass(rewardLevelText) {
        const rewardLevels = {
            "Negative Reward": 'btn-very-very-bad',
            "Very Low": 'btn-very-bad',
            "Low": 'btn-info',
            "Moderate": 'btn-good',
            "High": 'btn-very-good',
            "Very High": 'btn-very-very-good'
        };
    
        return rewardLevels[rewardLevelText] || 'btn-very-very-good';
    }

    overlay() {
        const popupId = `popup-reward-${this.props.row.id}`;
        return (
            <Popover id={popupId}>
                <Popover.Content>
                    {this.props.row.indicatortext}
                </Popover.Content>
            </Popover>
        );
    }

    render() {
        const rewardLevelText = this.props.row.rewardLevelText;
        let popup;

        if (CurrentUser && CurrentUser.hasProAccess && rewardLevelText) {
            popup = (
                <OverlayTrigger overlay={this.overlay()} trigger="focus" placement="auto">
                    <button
                        className={`btn btn-sm btn-block text-nowrap ${this.getClass(rewardLevelText)}`}
                        role="button"
                    >
                        {rewardLevelText}
                    </button>
                </OverlayTrigger>
            );
        } else if (this.props.row.upgradeurl !== '') {
            popup = <a href={this.props.row.upgradeurl} className="btn btn-sm btn-block btn-primary">Upgrade</a>;
        } else {
            popup = '';
        }

        return (
            <td>
                {popup}
            </td>
        );
    }
}

class Reward extends Column {
    get id() {
        return columnOptions.id;
    }

    get title() {
        return columnOptions.title;
    }

    sortAscending(a, b) {
        if (!a.rewardLevelText) {
            return 1;
        }

        if (!b.rewardLevelText) {
            return -1;
        }

        const aRewardLevel = REWARD_LEVELS_SORT[a.rewardLevelText];
        const bRewardLevel = REWARD_LEVELS_SORT[b.rewardLevelText]; 

        if (aRewardLevel < bRewardLevel) {
            return -1;
        }

        if (aRewardLevel > bRewardLevel) {
            return 1;
        }
        return super.sortAscending(a, b);
    }
    
    sortDescending(a, b) {
        if (!a.rewardLevelText) {
            return 1;
        }

        if (!b.rewardLevelText) {
            return -1;
        }

        const aRewardLevel = REWARD_LEVELS_SORT[a.rewardLevelText];
        const bRewardLevel = REWARD_LEVELS_SORT[b.rewardLevelText];

        if (aRewardLevel < bRewardLevel) {
            return 1;
        }

        if (aRewardLevel > bRewardLevel) {
            return -1;
        }
        return super.sortDescending(a, b);
    }

    get DetailColumn() {
        return DetailColumn;
    }

    get HeaderColumn() {
        return HeaderColumn;
    }
}

export default Reward; 